import { Check, Copy } from "lucide-react";
import { Button } from "@headerhawk/ui";
import { useCopiedFlag } from "@/lib/hooks/use-copied-flag";

interface CopyButtonProps {
  text: string;
  className?: string;
  /** Called once the text is on the clipboard, by either path. */
  onCopy?: () => void;
}

export function CopyButton({ text, className, onCopy }: CopyButtonProps) {
  const [copied, markCopied] = useCopiedFlag();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      markCopied();
      onCopy?.();
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      markCopied();
      onCopy?.();
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleCopy}
      className={className}
    >
      {copied ? (
        <>
          <Check className="h-4 w-4 mr-1" />
          Copied!
        </>
      ) : (
        <>
          <Copy className="h-4 w-4 mr-1" />
          Copy
        </>
      )}
    </Button>
  );
}
